import React, { useContext, useEffect, useRef, useState } from 'react'
import noteContext from '../context/notes/noteContext';
import NoteItem from './NoteItem'
import AddNote from './AddNote'
import { useNavigate } from 'react-router-dom';

export default function Notes(props) {
  const context = useContext(noteContext);
  let navigate=useNavigate();
  const { notes, getNotes, editNote } = context;
  const [note, setNote] = useState({ id: "", etitle: "", edescription: "", etag: "" })
  useEffect(() => {
    if(localStorage.getItem('token')){
    getNotes()
    }
    else{
      navigate("/login");
      props.showAlert("Login to get your notes","danger");
    }
    // eslint-disable-next-line
  }, [])
  const updateNote = (currentNote) => {
    ref.current.click();
    setNote({ id: currentNote._id, etitle: currentNote.title, edescription: currentNote.description, etag: currentNote.tag });
  }
  const ref = useRef(null)
  const refClose = useRef(null);
  const onChange = (e) => {
    // Whenever the target tag is change it will update its state too.
    setNote({ ...note, [e.target.name]: e.target.value })
  }
  const handleOnedit = () => {
    editNote(note.id, note.etitle, note.edescription, note.etag);
    refClose.current.click();
    props.showAlert("Note updated successfully","success");
  }
  return (
    <div className='my-3'>
      <AddNote showAlert={props.showAlert} />
      <button type="button" ref={ref} className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
        Launch demo modal
      </button>
      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Edit the Note</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form className='my-3'>
                <div className="mb-3">
                  <label htmlFor="etitle" className="form-label">Title</label>
                  <input type="text" value={note.etitle} className="form-control" name="etitle" id="etitle" aria-describedby="emailHelp" onChange={onChange}/>
                </div>
                <div className="mb-3">
                  <label htmlFor="edescription" className="form-label">Description</label>
                  <input type="text" value={note.edescription} className="form-control" name="edescription" id="edescription" onChange={onChange}/>
                </div>
                <div className="mb-3">
                  <label htmlFor="etag" className="form-label">Tag</label>
                  <input type="text" value={note.etag} className="form-control" name="etag" id="etag" onChange={onChange} />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button ref={refClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button disabled={note.etitle.length<5 || note.edescription.length<5} type="button" onClick={handleOnedit} className="btn btn-primary">Update Note</button>
            </div>
          </div>
        </div>
      </div>
      <div className="my-3">
        <h1>Your Notes</h1>
        <div className="container row">
          {/*if there is nothing to display then show the string && is used for this*/}
          {notes.length === 0 ? `No notes to display` : notes.map((note) => {
              return <NoteItem showAlert={props.showAlert} key={note._id} updateNote={updateNote} note={note} />
            })}
        </div>
      </div>
    </div>
  )
}
